
<template>
    <div class="card">
        <div class="header">
            <div class="title">修改任务模板</div>
        </div>
        <div class="form">
            <form @submit.prevent="handleSubmit">
                <div class="form-group-list">
                    <InputField
                        label="任务名称"
                        type="text"
                        id="name"
                        :modelValue="form.name"
                        placeholder="请输入任务名称"
                        required
                        @update:modelValue="(value) => handleModelValueUpdate('name', value)"
                    />
                    <SelectField
                        label="任务类型"
                        id="type"
                        :modelValue="form.type"
                        :options="typeList"
                        required
                        labelWidth="40%"
                        @update:modelValue="(value) => handleModelValueUpdate('type', value)"
                    />
                </div>
                <div class="form-group-list">
                    <SelectField
                        label="执行月份"
                        id="exeMonths"
                        :modelValue="form.exeMonths"
                        :options="exeMonthsList"
                        labelWidth="35%"
                        multiple
                        typeInfo="version2"
                        @update:modelValue="(value) => handleModelValueUpdate('exeMonths', value)"
                    />
                    <SelectField
                        label="执行日期"
                        id="exeDate"
                        :modelValue="form.exeDate"
                        :options="exeDateList"
                        labelWidth="40%"
                        multiple
                        typeInfo="version2"
                        @update:modelValue="(value) => handleModelValueUpdate('exeDate', value)"
                    />
                </div>
                <div class="form-group-list">
                        <SelectField
                            label="执行星期"
                            id="exeWeek"
                            :modelValue="form.exeWeek"
                            :options="exeWeekList"
                            labelWidth="35%"
                            multiple
                            typeInfo="version2"
                            @update:modelValue="(value) => handleModelValueUpdate('exeWeek', value)"
                        />
                        <SelectField
                            label="执行状态"
                            id="status"
                            :modelValue="form.status"
                            :options="statusList"
                            required
                            labelWidth="40%"
                            @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                        />
                </div>
                <div class="form-group-list form-group-list1">
                    <SelectField
                        label="任务说明"
                        id="remark"
                        :modelValue="form.remark"
                        :options="remarks"
                        required
                        labelWidth="13%"
                        multiple
                        @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                    />
                </div>
                <div class="form-group-list">
                    <div class="form-group" style="width: 100%;margin-top: 10px">
                        <label class="form-label" for="facility" style="width: 13%;color: #94a3b8">
                            <span style="color: #ff5a5a;">*</span>任务设备
                        </label>
                        <div style="width: 100%; margin-top: 10px">
                            <ButtonField
                                    text="添加"
                                    @click="changeStatus('facility')"
                                    style="margin-bottom: 10px; width: 15%"
                                    secondary
                            />
                            <Tablelist
                                :showCheckbox="false"
                                :list="selectedFacilityList"
                                :columns="tableColumns"
                                @action="handleAction"
                            >
                                <template #template-category="{ item }">
                                    <span v-if="item.category === 'sewage'">污水</span>
                                    <span v-if="item.category === 'rain'">雨水</span>
                                    <span v-if="item.type === 'well'">检查井</span>
                                    <span v-else-if="item.type === 'pipe'">管线</span>
                                    <span v-else>
                                      <DataDictFinder dictType="deviceType" :dictValue="item.type" iconType="text" />
                                    </span>
                                </template>
                            </Tablelist>
                        </div>
                    </div>
                </div>
                <div class="form-group-button">
                    <ButtonField text="关闭" @click="cancel" secondary width="40%"/>
                    <ButtonField text="保存" primary width="40%"/>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { fetchDetail, edit } from "../api/temp";
import { mapGetters } from "vuex";
import request from "@/api/request";
function fetchRemarks() {
    return request({
        url: "/model-analysis/inspect/task/remark/list",
    });
}

export default {
    props: {
        selectedFacilityList: {
            type: Array,
            default: () => [],
        },
        selectedMarkerList: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            form: {
                name: '',
                type: '',
                exeMonths: null,
                exeDate: null,
                exeWeek: null,
                executor: '',
                remark: [],
                status: ''
            },
            user: {},
            showCheckbox:false,
            userList: [],
            remarks: [],
            exeMonthsList:[
                { name: '1', value: 1 },
                { name: '2', value: 2 },
                { name: '3', value: 3 },
                { name: '4', value: 4 },
                { name: '5', value: 5 },
                { name: '6', value: 6 },
                { name: '7', value: 7 },
                { name: '8', value: 8 },
                { name: '9', value: 9 },
                { name: '10', value: 10 },
                { name: '11', value: 11 },
                { name: '12', value: 12 }
            ],
            exeWeekList:[
                {name:'1',value:1},{name:2,value:2},{name:'3',value:3},{name:'4',value:4},{name:'5',value:5},{name:'6',value:6},{name:'7',value:7}],
            exeDateList:[
                {name:'1',value:1},{name:'2',value:2},{name:'3',value:3},{name:'4',value:4},{name:'5',value:5},{name:'6',value: 6},{name:'7',value:7},{name:'8',value:8},{name:'9',value:9},{name:'10',value:10},{name:'11',value:11},{name:'12',value:12},{name:'13',value:13},{name:'14',value:14},{name:'15',value:15},{name:'16',value:16},{name:'17',value:17},{name:'18',value:18},{name:'19',value:19},{name:'20',value:20},{name:'21',value:21},{name:'22',value:22},{name:'23',value:23},{name:'24',value:24},{name:'25',value:25},{name:'26',value:26},{name:'27',value:27},{name:'28',value:28},{name:'29',value:29},{name:'30',value:30},{name:'31',value:31}],
            tableColumns: [
                {
                    key: 'id',
                    title: '编号',
                    field: 'id',
                    infotype: 'text'
                },
                {
                    key: 'category',
                    title: '类型',
                    field: 'category',
                    infotype: 'template'
                },
                {
                    key: 'actions',
                    title: '操作',
                    render: {
                        view: false, edit: false, delete: true,audit:false
                    }
                }
            ]
        };
    },

    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        typeList() {
            return this.findDataDict("taskType");
        },
        statusList() {
            return this.findDataDict("status");
        },
    },

    mounted() {
        const { id } = this.$route.query;
        if (id) {
            fetchDetail({ id }).then((res) => {
                console.log("detial", res);
                if (res) {
                    this.text = res;
                    this.form = {
                        id: res.id,
                        number: res.number,
                        name: res.name,
                        type: res.type,
                        exeMonths:res.exeMonths.split(","),
                        exeDate:res.exeDate.split(","),
                        exeWeek:res.exeWeek.split(","),
                        executor: res.executor,
                        remark: res.remark.split(" "),
                        status: res.status,
                    };
                    if (Array.isArray(res.facilityList)) {
                        this.$emit(
                            "changeFacility",
                            res.facilityList.map((item) => {
                                return {
                                    ...item,
                                    id: item.deviceId,
                                    startLnglat: item.xfrom
                                        ? [item.xfrom, item.yfrom]
                                        : undefined,
                                    endLnglat: item.xto ? [item.xto, item.yto] : undefined,
                                };
                            })
                        );
                    }

                    if (Array.isArray(res.pointList)) {
                        this.$emit(
                            "changeMarker",
                            res.pointList.map((item) => {
                                return {
                                    ...item,
                                    x: parseFloat(item.x),
                                    y: parseFloat(item.y),
                                };
                            })
                        );
                    }
                }
            });
        }
        fetchRemarks().then((res) => {
            if (Array.isArray(res.list)) {
                this.remarks = res.list.map(item => ({
                    name: item.remark,
                    value: item.remark
                }));
                this.remarks = Object.freeze(this.remarks);
            }
        });
    },

    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        handleAction(actionInfo) {
            const { type,  id } = actionInfo;
            switch(type) {
                case 'delete':
                    this.deleteText(id);
                    break;
            }
        },
        changeStatus(payload) {
            this.$emit("changeStatus", payload);
            if (payload === "marker") {
                this.$message.info("请点击地图拾取点位");
            } else {
                this.$message.info("请选择设备");
            }
        },
        deleteText(index) {
            this.$emit("deleteFacility", index);
        },
        removeMarker(index) {
            this.$emit("removeMarker", index);
        },

        cancel() {
            this.$router.go(-1);
        },

        handleSubmit() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            if (!this.form.name) {
                this.$message.error('任务名称不能为空');
                this.isSubmitting = false; // 重置标志
                return;
            }
            if (!this.form.type) {
                this.$message.error('任务类型不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.exeMonths && !this.form.exeDate && !this.form.exeWeek) {
                this.$message.error('请选择月份日期或星期');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.remark.length) {
                this.$message.error('任务说明不能为空');
                this.isSubmitting = false;
                return;
            }
            const params = {
                ...this.form,
                exeDate: this.form.exeDate ? this.form.exeDate.join(",") : "",
                exeMonths: this.form.exeMonths ? this.form.exeMonths.join(",") : "",
                exeWeek: this.form.exeWeek ? this.form.exeWeek.join(",") : "",
                facilityList: this.selectedFacilityList.map((item) => {
                    return {
                        ...item,
                        deviceId: item.id,
                        id: undefined,
                    };
                }),
                remark: this.form.remark ? this.form.remark.join(" ") : "",
            };
            console.log("params::",params)
            edit({
                id: this.text.id,
                ...params,
            })
                .then(() => {
                    this.cancel();
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    },
};
</script>

<style lang="less" scoped>
.card {
  position: fixed;
  top: 11vh;
  right: 1vw;
  z-index: 99;
  width: 40vw;
    background-color: var(--detail-bgcolor);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  height: 75vh;
  overflow: auto;

  & > .header {
    background-color: var(--default-bgcolor);
    position: sticky;
    top: 0;
    left: 0;
    z-index: 998;
    color: var(--cardText-color);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.5vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}

.form {
  padding: 1em;

  .center {
    padding: 1em;
  }
}

.form-group-list{
  display: flex;
  justify-content: space-between;
  width: 95%;
}

.form-group {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  width: 45%;
}

.form-group-list1 .form-group{
  width: 100%;
}
.form-group-list1 .form-label{
  width: 13%!important;
}

.form-group-button{
  display: flex;
  justify-content: space-between;
  width: 50%;
  margin: auto;
}

.filter-select {
  padding: 0.75rem 1rem;
  background: rgb(14 27 52);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 90%;
}

.filter-select:focus {
  outline: none;
  border-color: #00ff96;
  box-shadow: 0 0 10px rgba(0, 255, 150, 0.2);
}

::v-deep .ant-calendar-picker-icon{
  color:rgb(148 163 184);
}
::v-deep .ant-input{
  background: rgb(14 27 52);
  border: 1px solid rgba(0, 255, 150, 0.2);
  border-radius: 6px;
  color: #fff;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  height:46px;
}

</style>
